namespace $.$$ {
	export class $bog_calculator_app extends $.$bog_calculator_app {}
}
